import { createSlice } from "@reduxjs/toolkit";

export const counterSlice = createSlice({
    name: "counter",
  initialState: {
    ids: 1,
    count: [{id: 0  , description: "Learn Microservices", done: false, targetDate: "2024-04-20" },
    {id: 1, description: "Visit Barcelona", done: false, targetDate: "2024-01-25"} ]
  },
  reducers: {
    addTodoReducer: (state, action) => {
      state.ids= state.ids +1;
     state.count = [...state.count ,action.payload]

    },
    deleteTodoAction: (state, action) => {
      const updatedPeople = state.count.filter(person => person.id !== action.payload);
      state.count = updatedPeople;
  
    },
    updateTdoAction: (state, action) => {
    

console.log(action.payload.id)
      const indexToReplace = state.count.findIndex(item => item.id.toString() === action.payload.id);
      console.log(indexToReplace)

     state.count[indexToReplace] = action.payload;
     
    }

  }
});

const findTodo = (array,id) => {
  return array.find(person => person.id === id);
};

// Action creators are generated for each case reducer function
export const { addTodoReducer, deleteTodoAction, updateTdoAction } = counterSlice.actions;

export default counterSlice.reducer;
